import React, { useState, useEffect, useContext } from "react";
import { faCommentDots, faPen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";
import useTheme from "./useTheme.js";
import { LoginContext } from "../context/LoginContext";

const Comments = (props) => {
  const loginContext = useContext(LoginContext);

  const [showComments, setShowComments] = useState(false);

  const [showAddComment, setShowAddComment] = useState(false);

  const [showSignup, setShowSignup] = useState(false);

  const [showRes, setShowRes] = useState(false);

  const [comments, setComments] = useState([]);

  const [title, setTitle] = useState("");

  const [matn, setMatn] = useState("");

  const [res, setRes] = useState("");

  const [mobile, setMobile] = useState("");

  const [pass, setPass] = useState("");

  const [name, setName] = useState("");

  const [mobileValidate, setMobileValidate] = useState(true);

  const [passValidate, setPassValidate] = useState(true);

  const [nameValidate, setNameValidate] = useState(true);

  const [exist, setExist] = useState(0);

  const [result, setResult] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [isSend, setIsSend] = useState(false);

  const [theme, switchTheme] = useTheme();

  const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
  const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

  useEffect(() => {
    const formData = new FormData();
    formData.append("getComments", 1);
    formData.append("pkKala", props.pk);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setComments(data.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  const titleHandle = (e) => {
    setTitle(e.target.value);
  };

  const matnHandle = (e) => {
    setMatn(e.target.value);
  };

  const addComment = () => {
    setShowAddComment(false);
    if (matn.length < 5) {
      setShowRes(true);
      setRes("لطفا متن مورد نظر را وارد کنید");
      return;
    }
    setIsLoading(true);
    setShowRes(true);
    const formData = new FormData();
    formData.append("setComments", 1);
    formData.append("pkKala", props.pk);
    formData.append("barcode", props.barcode);
    formData.append("mobile", loginContext.userInfo.mobile);
    formData.append("vitrinCode", props.vitrinCode);
    formData.append("title", title);
    formData.append("matn", matn);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setIsLoading(false);
        setRes(data.data);
        if (data.result) {
          setIsSend(true);
          setMatn("");
        }
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
        setRes("اشکال در برقراری ارتباط با سرور");
      });
  };

  const mobileHandle = (e) => {
    if (isNaN(e.target.value)) {
      return;
    }
    setMobile(e.target.value);
  };

  const passHandle = (e) => {
    setPass(p2e(a2e(e.target.value)));
  };

  const nameHandle = (e) => {
    setName(e.target.value);
  };

  const checkSignup = () => {
    if (mobile.length < 11 || mobile[0] + mobile[1] != "09") {
      setMobileValidate(false);
      return;
    } else {
      setMobileValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("checkSignup", 1);
    formData.append("mobile", mobile);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          setExist(1);
        } else {
          setExist(2);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const login = () => {
    if (pass.length < 4) {
      setPassValidate(false);
      return;
    } else {
      setPassValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("login", 1);
    formData.append("mobile", mobile);
    formData.append("password", pass);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          loginContext.login(data.data);
          setShowSignup(false);
        } else {
          setResult("رمز عبور اشتباه است");
          setExist(3);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const forgetPass = () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("forget_pass", 1);
    formData.append("mobile", mobile);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setResult(data.data);
          setExist(3);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(3);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const signup = () => {
    if (name.length < 6) {
      setNameValidate(false);
      return;
    } else {
      setNameValidate(true);
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("signUp", 1);
    formData.append("mobile", mobile);
    formData.append("name", name);
    formData.append("vitrinCode", props.vitrinCode);
    formData.append("address", "");
    formData.append("work", "مشتری خانگی");
    formData.append("moaref", "");
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.result) {
          setExist(4);
        } else {
          setExist(5);
        }
        setResult(data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setExist(5);
        setResult("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
      });
  };

  const modal = () => {
    if (!isLoading) {
      if (exist === 0) {
        return (
          <div>
            <h6 className="text-center">موبایل</h6>
            <input
              className={
                !mobileValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              onChange={mobileHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-success"
                onClick={() => {
                  checkSignup();
                }}
              >
                ادامه
              </button>
            </div>
          </div>
        );
      } else if (exist === 1) {
        return (
          <div>
            <h6 className="text-center">موبایل</h6>
            <input
              className="form-control rtl"
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              readOnly
            ></input>
            <h6 className=" mt-3 text-center">رمزعبور</h6>
            <input
              className={
                !passValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="password"
              value={pass}
              onChange={passHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-info mr-2"
                onClick={() => {
                  forgetPass();
                }}
              >
                فراوشی رمزعبور
              </button>
              <button
                className="btn btn-success"
                onClick={() => {
                  login();
                }}
              >
                ورود
              </button>
            </div>
          </div>
        );
      } else if (exist === 2) {
        return (
          <div>
            <h6 className="text-center">
              <FontAwesomeIcon
                onClick={() => {
                  setExist(0);
                }}
                icon={faPen}
              />{" "}
              موبایل
            </h6>
            <input
              className="form-control rtl"
              type="text"
              inputMode="numeric"
              maxLength="11"
              value={mobile}
              readOnly
            ></input>
            <h6 className=" mt-3 text-center">نام و نام خانوادگی</h6>
            <input
              className={
                !nameValidate
                  ? "form-control is-invalid rtl"
                  : "form-control rtl"
              }
              type="text"
              value={name}
              onChange={nameHandle}
            ></input>
            <div className="mt-3 text-center">
              <button
                className="btn btn-success"
                onClick={() => {
                  signup();
                }}
              >
                ثبت نام
              </button>
            </div>
          </div>
        );
      } else if (exist === 3) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-danger"
              onClick={() => {
                setPass("");
                setExist(1);
              }}
            >
              بازگشت
            </button>
          </div>
        );
      } else if (exist === 4) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-success"
              onClick={() => {
                setExist(1);
              }}
            >
              ورود
            </button>
          </div>
        );
      } else if (exist === 5) {
        return (
          <div className="text-center">
            <p>{result}</p>
            <button
              className="btn btn-success"
              onClick={() => {
                setExist(2);
              }}
            >
              ثبت نام مجدد
            </button>
          </div>
        );
      }
    } else {
      return (
        <div className="row justify-content-center m-5 p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      );
    }
  };

  return (
    <>
      <FontAwesomeIcon
        icon={faCommentDots}
        size="2x"
        color="#5bc0de"
        onClick={() => setShowComments(true)}
      />
      <Modal
        show={showComments}
        onHide={() => {
          setShowComments(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark justify-content-center"
              : "bg-dark text-light justify-content-center"
          }
        >
          نظرات
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {comments.length > 0 ? (
            comments.map((item, index) => (
              <div
                key={index}
                className={
                  theme === "light"
                    ? "card bg-light mb-3"
                    : "card bg-light text-dark mb-3"
                }
              >
                {/* <div className="card-header">{item.title}</div> */}

                <div className="card-body">
                  <h5 className="card-title">{item.title}</h5>
                  <p className="card-text">{item.matn}</p>
                </div>

                <div className="card-footer inlined">
                  <small className="text-muted">{item.tarikh}</small>
                  <small className="text-muted">{item.name}</small>
                </div>
              </div>
            ))
          ) : (
            <p>نظری برای این محصول یافت نشد</p>
          )}
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-success"
            onClick={() => {
              setShowComments(false);
              setShowAddComment(true);
            }}
          >
            افزودن نظر
          </button>
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowComments(false);
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAddComment}
        onHide={() => {
          setShowAddComment(false);
          setShowComments(true);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark justify-content-center"
              : "bg-dark text-light justify-content-center"
          }
        >
          افزودن نظر
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {loginContext.loginState ? (
            <>
              <div className="mt-4">
                <textarea
                  className={"form-control text-center rtl"}
                  placeholder="متن"
                  value={matn}
                  onChange={matnHandle}
                />
              </div>
            </>
          ) : (
            <p>برای افزودن نظر ابتدا باید وارد شوید</p>
          )}
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light"
              ? "bg-light text-dark inlined"
              : "bg-dark text-light inlined"
          }
        >
          <button
            className="btn btn-danger"
            onClick={() => {
              setShowAddComment(false);
              setShowComments(true);
            }}
          >
            انصراف
          </button>
          {loginContext.loginState ? (
            <button
              className="btn btn-success"
              onClick={() => {
                addComment();
              }}
            >
              ثبت
            </button>
          ) : (
            <>
              <button
                onClick={() => setShowSignup(true)}
                className={theme === "light" ? "btn btn-dark" : "btn btn-light"}
              >
                ورود{" "}
              </button>
              <Modal
                show={showSignup}
                onHide={() => {
                  setShowSignup(false);
                }}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                scrollable
              >
                <Modal.Header
                  closeButton
                  className={
                    theme === "light"
                      ? "bg-light text-dark"
                      : "bg-dark text-light"
                  }
                ></Modal.Header>
                <Modal.Body
                  className={
                    theme === "light"
                      ? "bg-light text-dark"
                      : "bg-dark text-light"
                  }
                >
                  {modal()}
                </Modal.Body>
              </Modal>
            </>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRes}
        onHide={() => {
          setShowRes(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark justify-content-center"
              : "bg-dark text-light justify-content-center"
          }
        ></Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {isLoading ? (
            <div className="row justify-content-center m-5 p-5">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div>{res}</div>
          )}
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowRes(false);
              if (!isSend) {
                setShowAddComment(true);
              }
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Comments;
